import React from 'react';
import { SpecsPanel } from '@marvelapp/ui-internal';
import PanelLine from './PanelLine';
export default function PanelFonts(_a) {
    var fonts = _a.fonts;
    return (React.createElement(SpecsPanel, { title: "Fonts" }, fonts.map(function (font) { return (React.createElement(PanelLine, { key: font }, font)); })));
}
